import { NgModule, isDevMode ,CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { JwtHelperService, JwtInterceptor, JWT_OPTIONS } from '@auth0/angular-jwt';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiService } from './Services/Apis/api.service';
import { HttpinterceptorService } from './Services/interceptors/httpinterceptor.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { DatePipe, DecimalPipe } from '@angular/common';
import { MinisharedModule } from './shared/minishared/minishared.module';
import { PrinterPipe } from './pages/userdashboard/printer.pipe';




@NgModule({
  declarations: [AppComponent, PrinterPipe],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(),
    NgxPaginationModule,
    AppRoutingModule,
    MinisharedModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
    enabled: !isDevMode(),

  // Register the ServiceWorker as soon as the application is stable
  // or after 30 seconds (whichever comes first).
  registrationStrategy: 'registerWhenStable:30000'
})],
schemas: [ CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
   
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpinterceptorService,
      multi: true
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    JwtHelperService,
    ApiService,
    DatePipe,
    DecimalPipe


  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
